import React from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { BRAND } from "../../lib/config";
import { Activity, LifeBuoy, ArrowUpRight } from "lucide-react";

function TrustLink({ href, title, desc, icon: Icon }) {
  return (
    <a
      href={href}
      className="group flex items-start justify-between gap-6 rounded-2xl border border-white/10 bg-white/[0.02] p-5 hover:bg-white/[0.04] transition"
    >
      <div className="flex gap-4">
        <div className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/[0.03]">
          <Icon className="h-5 w-5 text-cyan-300" />
        </div>
        <div>
          <div className="text-sm font-semibold text-white">{title}</div>
          <div className="mt-1 text-sm leading-6 text-white/60">{desc}</div>
        </div>
      </div>

      <ArrowUpRight className="h-5 w-5 text-white/40 transition group-hover:text-white/70" />
    </a>
  );
}

export default function TrustBand() {
  return (
    <section className="bg-[#070A0F] py-16">
      <Container>
        <Card className="p-7 sm:p-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:items-center">
            <div>
              <div className="text-xs font-semibold tracking-wider text-white/50">
                TRUST & TRANSPARENCY
              </div>
              <h3 className="mt-3 text-2xl font-semibold text-white leading-tight">
                Clear communication when it matters<span className="text-cyan-300">.</span>
              </h3>
              <p className="mt-3 text-sm leading-6 text-white/65">
                We publish service updates and keep resource allocation simple. No vague promises — just
                clear status and real support.
              </p>
            </div>

            <div className="lg:col-span-2 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <TrustLink
                href={BRAND.statusUrl}
                title="Status"
                desc="Incidents, maintenance, and uptime updates."
                icon={Activity}
              />
              <TrustLink
                href={BRAND.supportUrl}
                title="Support"
                desc="Discord + tickets. Humans, not scripts."
                icon={LifeBuoy}
              />
            </div>
          </div>
        </Card>
      </Container>
    </section>
  );
}
